var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorScurtInaltaTensiune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 80,
    viewBox: "0 0 91 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 39.75,
    x2: 60,
    y2: 39.75,
    stroke: "black",
    strokeWidth: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorScurtInaltaTensiune);
export default __webpack_public_path__ + "static/media/conductor_scurt_inalta_tensiune.b0152a6e820a33abbcb37ed82533daaa.svg";
export { ForwardRef as ReactComponent };